window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.fixedHeader($(window));
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedHeader($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		// animation
		AOS.init({
			once: true,
		});

		// navigation
		new VGNav({
			expand: 'lg'
		}, {
			afterClick: function () {
				$('.vg-nav-hamburger, .vg-nav-sidebar, .vg-nav-overlay').removeClass('show');
				$('body').removeClass('vg-nav-sidebar-open');
			}
		});

		// Scrollbar
		let $scrollbarNav = $('.scrollbar-inner');
		if ($scrollbarNav.length) {
			$scrollbarNav.scrollbar();
		}

		// Input mask
		$('.input-mask-phone').inputmask('8 (999) 999-99-99', {clearIncomplete: true, showMaskOnHover: true}).on('paste', function (e) {
			$(this).val(normalize_phone_inputmask(e.originalEvent.clipboardData.getData('text')));
			return false;
		}).on('change', function () {
			$(this).val(normalize_phone_inputmask($(this).val()));
		});

		// Load more
		$('.btn-load-more-portfolio').vegasLoadMore({
			limit: 6,
			offset: 6,
			route: '/portfolio/load',
			onLoad: function($self, data) {
				let target = $self.attr('data-target');

				$(target).append(data.view);

				if (!data.view) {
					$self.hide();
				}
			}
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	carousel: function () {
		VegasCarousel.init();
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default, .page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');

		$(".vg-form--close-fancy").on('submit-success', function () {
			$.fancybox.close();
		});
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.vg-header-wrapper'),
			scroll = $self.scrollTop(),
			$body = $('body');

		if (scroll > 0) {
			$body.addClass('vg-hdr--is-scroll');

			$sticky.addClass('fixed');
			$body.addClass('vg-hdr--is-fixed');

		} else {
			$sticky.removeClass('fixed');
			$body.removeClass('vg-hdr--is-scroll vg-hdr--is-fixed');
		}
	},
};
